// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__ovcC6"};